import { render } from "./BlockContact.vue?vue&type=template&id=2149422f&scoped=true"
import script from "./BlockContact.vue?vue&type=script&lang=js"
export * from "./BlockContact.vue?vue&type=script&lang=js"

import "./BlockContact.vue?vue&type=style&index=0&id=2149422f&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2149422f"]])

export default __exports__